"use client";
import React from "react";
import type { IconProps } from "./types";

interface SwapArrowsIconProps extends IconProps {
  style?: React.CSSProperties;
}

export default function SwapArrowsIcon({
  size = 12,
  width,
  height,
  color = "currentColor",
  className,
  style,
}: SwapArrowsIconProps) {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 1L3 9M3 9L1 7M3 9L5 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11L9 3M9 3L7 5M9 3L11 5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
